export { default } from './IconGroupPanel';
